import { Button, Grid, Stack, Typography } from '@mui/material'
import { blue } from '@mui/material/colors'
import { Box } from '@mui/system'
import React from 'react'

export const HeroSection = () => {
  return (
    <Grid container spacing={2} sx={{
            ml: '2px',
            mb: 5,
            height: "100vh",
            alignItems: "center"
         }}>
        <Grid item xs={11} md={6}>
            <Box sx={{ pt: 2}}>
                <Typography variant="h3" gutterBottom fontWeight={700}>
                    👋Hi!, I`m Dave.
                </Typography>
                <Box 
                    sx={{
                        display:{
                            xs:"none",
                            sm:"block"
                        }}}
                        >
                    <Typography variant="h3" gutterBottom>
                        FullStack Web Developer.
                    </Typography>
                </Box>
                <Typography gutterBottom color="text.secondary">
                    I’m a self-taught FullStack Developer and school-taught Computer Scientist from Zimbabwe.
                    I've been building websites since 2019 mostly for fun, but with a focus on responsive design.
                </Typography>
                <Stack direction="row">
                    <Button variant="contained" size="large" href="#contact" sx={{ mt: 2 }}>
                        Hire me!
                    </Button>
                    <Button variant="outlined" size="large" href="#skills" sx={{ mt: 2, mx: 2 }}>
                        See My Skills
                    </Button>
                </Stack>
                
            </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
            <Box sx={{
                bgcolor: "grey.500",
                height: 450,
                width: {
                    lg:390,
                    xl:450
                },
                borderRadius: "0 0 0 80px",
                position: "relative",
                ml:10,
                display:{
                    xs: "none",
                    md:"block"
                }
            }}>
                <Box sx={{
                    bgcolor: blue[500],
                    height: 450,
                    width:{
                        lg:390,
                        xl:450
                    },
                    position: "relative",
                    top: 20,
                    right: 20,
                    borderRadius: "0 0 0 80px",
                    overflow: "hidden",
                    backgroundImage: 'url("images/david.jpg")',
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}>
                    {/* <img src="images/david.jpg" alt="Dave" height="500" width="500" /> */}
                </Box>
            </Box>
        </Grid>
    </Grid>
  )
}
